import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  CircleExclamationIconStyled,
  MessageStyled,
  TrlFeedbackStyled,
} from './TrlNoDataFeedback.styled';

export const TrlNoDataFeedback = ({ margin, height }) => (
  <TrlFeedbackStyled id="divNoDataFeedback" margin={margin} height={height}>
    <CircleExclamationIconStyled icon={faCircleExclamation} />
    <MessageStyled>
      <FormattedMessage id="TRLT_UI-NO_DATA_SHOW" />
    </MessageStyled>
  </TrlFeedbackStyled>
);

TrlNoDataFeedback.propTypes = {
  margin: PropTypes.string,
  height: PropTypes.string,
};
